import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./Sidebar.css";
import title from "../../src/images/title.png";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PieChartIcon from "@mui/icons-material/PieChart";
import { logoutApi } from "../api/Users";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { UilBars } from "@iconscout/react-unicons";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DescriptionIcon from "@mui/icons-material/Description";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BusinessIcon from "@mui/icons-material/Business";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import HandymanIcon from "@mui/icons-material/Handyman";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { ContactPhoneSharp, ContentPaste, ContentPasteSearch, EditNoteSharp, NoteAlt, PostAddTwoTone, RateReviewTwoTone,PageviewOutlined, AddTaskOutlined, AddHomeWorkOutlined } from "@mui/icons-material";
import { NextWeek, PlusOne } from "@material-ui/icons";
import ViewAllNotices from "./sidebarIcons/ViewAllNotices";
import newNotice from "./sidebarIcons/NewNotice";
import PaidIcon from "@mui/icons-material/Paid";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ViewAllGuidelines from "./sidebarIcons/ViewAllGuidelines";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import FYBudget from "../../src/Pages/Fy_Budget_allocation";
import SavingsIcon from "@mui/icons-material/Savings";
import PaymentsIcon from "@mui/icons-material/Payments";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import { icon } from "leaflet";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import ScheduleIcon from '@mui/icons-material/Schedule';
import FeedbackIcon from '@mui/icons-material/Feedback';
import PersonIcon from '@mui/icons-material/Person';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CollectionsIcon from '@mui/icons-material/Collections';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import BulkSmsIcon from '@mui/icons-material/Message';
import TeacherIcon from '@mui/icons-material/EmojiPeople';
import SingleBedIcon from '@mui/icons-material/SingleBed';
import EventIcon from '@mui/icons-material/Event';
import ReceiptIcon from '@mui/icons-material/Receipt';



const Sidebarrs = (props) => {
  const { t } = useTranslation();
  const handleClick = (e) => {
    i18next.changeLanguage(e.target.value);
    localStorage.setItem("selectedLanguage", e.target.value);
  };
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location
  const [activeMenu, setActiveMenu] = useState("/dashboard");
  const [HostelActiveMenu, setHostelActiveMenu] = useState("/dashboard");
  useEffect(() => {
    // Update active menu based on location change
    setActiveMenu(location.pathname);
    setHostelActiveMenu(location.pathname);
  }, [location.pathname]);

  function logout() {
    logoutApi().then((res) => {});
    localStorage.setItem("alert", "Logged out");
    setTimeout(() => {
      sessionStorage.clear();
      Cookies.remove("userId");
      navigate("/login");
    }, 500);
  }

  const [expanded, setExpaned] = useState(true);

  function toggleSidebar() {
    setExpaned(!expanded);
  }

  const sidebarMenuItems = [
    {
      label: "Dashboard",
      icon: GridViewRoundedIcon,
      path: "/dashboard",
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
    },
    {
      label: "Manage Login",
      icon: WalletRoundedIcon,
      allowedRoles: [14],
      subMenu: [
        {
          label: "Open New Hostel",
          icon: PersonAddIcon,
          path: "/create-hostel-login",
          allowedRoles: [14],
        },
        {
          label: "Open New School",
          icon: PersonAddIcon,
          path: "/add-school",
          allowedRoles: [14],
        },
        {
          label: "Assign Head Master",
          icon: PersonAddIcon,
          path: "/assign-headmaster",
          allowedRoles: [14],
        },
        // {
        //   label: "Assign HeadMaster",
        //   icon: PersonAddIcon,
        //   path: "/assign-headmaster",
        //   allowedRoles: [1],
        // },
        // {
        //   label: "Assign Asst. HeadMaster",
        //   icon: PersonAddIcon,
        //   path: "/assign-asst-headmaster",
        //   allowedRoles: [1],
        // },
      ],
    },
    {
      label: "My Profile",
      icon: AccountCircleIcon,
      path: "/myprofile",
      allowedRoles: [9],
    },
    {
      label:"Teacher Proficiency",
      icon:GridViewRoundedIcon,
      path: "/teacher-proficiency",
      allowedRoles:[9]
    },
    {
      label: "Past Positions & Transfers",
      icon: GridViewRoundedIcon,
      path: "/teacher-previous-transfers",
      allowedRoles: [9],
    },

    {
      label: "Requirements",
      icon: PlaylistAddCheckIcon,
      allowedRoles: [4, 5, 6, 7],
      subMenu: [
        {
          label: "Raise",
          icon: AddCircleIcon,
          path: "/hostel-requirement",
          allowedRoles: [1, 4],
        },
        {
          label: props.role == 7 ? "View" : "Approve",
          icon: props.role == 7 ? DoneAllIcon : DoneAllIcon,
          path: "/bulk-approval",
          allowedRoles: [1, 5, 6, 7, 8, 10, 11, 12, 13],
        },
        {
          label: "Track",
          icon: DescriptionIcon,
          path: "/trackrequirements",
          allowedRoles: [1, 4, 5, 6, 7],
        },
        // {
        //   label: "Track",
        //   icon: DescriptionIcon,
        //   path: "/trackrequirements-DM",
        //   allowedRoles: [7],
        // },

        {
          label: "Confirm Delivery",
          icon: DescriptionIcon,
          path: "/confirmdelivery",
          allowedRoles: [1, 4],
        },
        {
          label: "Completed",
          icon: CheckCircleIcon,
          path: "/completereq",
          allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
        },
        {
          label: "Rejected",
          icon: CancelIcon,
          path: "/rejectedrequirements",
          allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
        },
      ],
    },
    {
      label: "Fund Management",
      icon: SavingsIcon,
      allowedRoles: [6, 8],
      subMenu: [
        // {
        //   label: "Approve",
        //   icon:
        //     props.role == 7 || props.role == 12 || props.role == 13
        //       ? DoneAllIcon
        //       : ViewAllNotices,
        //   path: "/bulk-approval",
        //   allowedRoles: [11],
        // },
        {
          label: "Completed",
          icon: CheckCircleIcon,
          path: "/completereq",
          allowedRoles: [8],
        },
        {
          label: "Rejected",
          icon: CancelIcon,
          path: "/rejectedrequirements",
          allowedRoles: [8],
        },
        {
          label: "HQ Fund Allocation",
          icon: PaymentsIcon,
          path: "/fy-budget-allocation",
          allowedRoles: [8],
        },
        {
          label: "District Fund Allocation",
          icon: GridViewRoundedIcon,
          path: "/limits-allocation",
          allowedRoles: [8],
        },
        // {
        //   label: "Limit Allocation",
        //   icon: GridViewRoundedIcon,
        //   path: "/liimit-allocationDWO",
        //   allowedRoles: [6],
        // },
        {
          label: "Fulfillment",
          icon: PieChartIcon,
          path: "/fulfillment",
          allowedRoles: [6],
        },
        {
          label: "Request Fund",
          icon: PieChartIcon,
          path: "/request-budget",
          allowedRoles: [6],
        },
        {
          label: "Fund Utilization",
          icon: PieChartIcon,
          path: "/fund-utilization",
          allowedRoles: [6],
        },
      ],
    },
    // {
    //   label: "Fund Management",
    //   icon: SavingsIcon,
    //   allowedRoles: [1, 6,7, 8, 10, 11, 12, 13],
    //   subMenu: [
    //     {
    //       label: "Raise",
    //       icon: AddCircleIcon,
    //       path: "/hostel-requirement",
    //       allowedRoles: [1, 4],
    //     },
    //     {
    //       label: "Approve",
    //       icon:
    //         props.role == 7 || props.role == 12 || props.role == 13
    //           ? DoneAllIcon
    //           : ViewAllNotices,
    //       path: "/bulk-approval",
    //       allowedRoles: [5, 6, 8, 11],
    //     },
    //     {
    //       label: "Track",
    //       icon: DescriptionIcon,
    //       path: "/trackrequirements",
    //       allowedRoles: [1, 4, 5, 6, 8, 10, 11, 12, 13],
    //     },
    //     {
    //       label: "Track",
    //       icon: DescriptionIcon,
    //       path: "/trackrequirements-DM",
    //       allowedRoles: [7],
    //     },
    //     {
    //       label: "Confirm Delivery",
    //       icon: DescriptionIcon,
    //       path: "/confirmdelivery",
    //       allowedRoles: [1, 4],
    //     },
    //     {
    //       label: "Completed",
    //       icon: CheckCircleIcon,
    //       path: "/completereq",
    //       allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    //     },
    //     {
    //       label: "Rejected",
    //       icon: CancelIcon,
    //       path: "/rejectedrequirements",
    //       allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
    //     },
    //     {
    //       label: "FY Fund Allocation",
    //       icon: PaymentsIcon,
    //       path: "/fy-budget-allocation",
    //       allowedRoles: [1, 8, 10, 11, 12, 13],
    //     },
    //     {
    //       label: "Limits Allocation",
    //       icon: GridViewRoundedIcon,
    //       path: "/limits-allocation",
    //       allowedRoles: [1, 8, 10, 11, 12, 13],
    //     },
    //     {
    //       label: "Limit Allocation",
    //       icon: GridViewRoundedIcon,
    //       path: "/liimit-allocationDWO",
    //       allowedRoles: [6],
    //     },
    //     {
    //       label: "Fulfillment",
    //       icon: PieChartIcon,
    //       path: "/fulfillment",
    //       allowedRoles: [6],
    //     },
    //     {
    //       label: "Request Fund",
    //       icon: PieChartIcon,
    //       path: "/request-budget",
    //       allowedRoles: [6],
    //     },
    //     {
    //       label: "Fund Utilization",
    //       icon: PieChartIcon,
    //       path: "/fund-utilization",
    //       allowedRoles: [6],
    //     },
    //   ],
    // },
    {
      label: "Manage Amenity",
      icon: BusinessIcon,
      allowedRoles: [1, 4],
      subMenu: [
        {
          label: "Create Amenity Sub Type",
          icon: AddCircleOutlineIcon,
          path: "/add-asset-type",
          allowedRoles: [1],
        },
        {
          label: "Manage Stock",
          icon: AddCircleIcon,
          path: "/manage-stock",
          allowedRoles: [1, 4],
        },
        {
          label: "Amenity Lifespan",
          icon: AddCircleIcon,
          path: "/amenity-life-span",
          allowedRoles: [1, 4],
        },
      ],
    },

    // {
    //   label: "Take Survey",
    //   icon: QuestionAnswerIcon,
    //   path: "/take-survey",
    //   allowedRoles: [2,3,4,5,6,7,9,10,11],
    // },

    {
      label: "Asset Allocation",
      icon: GridViewRoundedIcon,
      path: "/add-assets",
      allowedRoles: [999],
    },
    {
      label: "Creative Board",
      icon: ContentPaste,
      allowedRoles: [4, 5, 6, 7, 8, 11, 12, 13],
      subMenu: [
        {
          label: "Add Notice",
          icon: NoteAlt,
          path: "/add-notice",
          allowedRoles: [4, 5, 6, 7, 8, 11, 12, 13],
        },
        // {
        //   label: ("View All"),
        //   icon: ViewAllNotices,
        //   path: "/view-notices",
        //   allowedRoles: [4, 5, 6, 7, 8],
        // },
        {
          label: "View All",
          icon: ViewAllGuidelines,
          path: "/sample-notice",
          allowedRoles: [4, 5, 6, 7, 8, 11, 12, 13],
        },
      ],
    },
    {
      label: "Guidelines",
      icon: AssignmentIcon,
      allowedRoles: [4, 5, 6, 7, 8, 11, 12, 13],
      subMenu: [
        {
          label: "Add Guideline",
          icon: NoteAlt,
          path: "/add-guideline",
          allowedRoles: [8, 11, 12, 13],
        },
        {
          label: "View All",
          icon: ViewAllGuidelines,
          path: "/view-guidelines",
          allowedRoles: [4, 5, 6, 7, 8, 11, 12, 13],
        },
      ],
    },
    {
      label: "Checklist/Survey",
      icon: QuestionAnswerIcon,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
      subMenu: [
        {
          label: "All Checklists",
          icon: QuestionAnswerIcon,
          path: "/all-checklist",
          allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
        },

        {
          label: "Fill Checklist",
          icon: QuestionAnswerIcon,
          path: "/fill-checklist",
          allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
        },
        {
          label: "Report",
          icon: QuestionAnswerIcon,
          path: "/checklist-report",
          allowedRoles: [5, 6, 7, 8, 11, 12, 13],
        },
      ],
    },

    {
      label: "Program Monitoring",
      icon: Diversity3Icon,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
      subMenu: [
        {
          label: "All Programs",
          icon: Diversity3Icon,
          path: "/all-programs",
          allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
        },
        // {
        //   label: "Launch New Program",
        //   icon: Diversity3Icon,
        //   path: "/launch-program",
        //   allowedRoles: [1, 4, 5, 6, 7, 8, 10, 11, 12, 13],
        // },
        {
          label: "Fill Program",
          icon: Diversity3Icon,
          path: "/fill-program",
          allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
        },
        {
          label: "Report",
          icon: QuestionAnswerIcon,
          path: "/program-report",
          allowedRoles: [5, 6, 7, 8, 11, 12, 13],
        },
      ],
    },
    {
      label: "Student Details",
      icon: SupervisedUserCircleIcon,
      path: "/student-details",
      allowedRoles: [1, 4, 9],
    },
    {
      label: "Staff Details",
      icon: AccountCircleIcon,
      path: "/staffdetails",
      allowedRoles: [1, 4],
    },
    
    {
      label: "Attendance",
      icon: EditNoteSharp,
      path: "/attendance",
      allowedRoles: [9],
    },
    {
      label: "Contact Directory",
      icon: ContactPhoneSharp,
      path: "/contact-details",
      allowedRoles: [9],
    },
    {
      label: "Assignments",
      icon: AssignmentIcon,
      path: "/assignments",
      allowedRoles:[9],
    },
    {
      label: "View Exam Marks",
      icon: PageviewOutlined,
      path: "/view-exam-marks",
      allowedRoles: [9],
    },
    {
      label: "Activity",
      icon: AddTaskOutlined,
      path: "/all-activity",
      allowedRoles: [9],
    },
    {
      label: "Download Homework",
      icon: AddHomeWorkOutlined,
      path: "/download-daily-homework",
      allowedRoles: [9],
    },

    // {
    //   label: "My Students",
    //   icon: SupervisedUserCircleIcon,
    //   path: "/mystudents",
    //   allowedRoles: [9],
    // },
    {
      label: "My Profile",
      icon: AccountCircleIcon,
      path: "/studentprofile",
      allowedRoles: [10],
    },
    {
      label: "Student Reports",
      icon: EqualizerIcon,
      path: "/students-report",
      allowedRoles: [4],
      subMenu: [
        {
          label: "Alumni Student Report",
          icon: PieChartIcon,
          path: "/AlumniStudent-Report",
          allowedRoles: [4],
        },
        {
          label: "Student Request Approval Report",
          icon: PieChartIcon,
          path: "/studentRequestApproval-report",
          allowedRoles: [4],
        },
        {
          label: "Student SMS Report",
          icon: PieChartIcon,
          path: "/studentSMS-report",
          allowedRoles: [4],
        },
        {
          label: "Student Information Report",
          icon: PieChartIcon,
          path: "/studentInformation-report",
          allowedRoles: [4],
        },
        {
          label: "Promote, Demote, Detained Student Report",
          icon: PieChartIcon,
          path: "/promoteDemoteDetainedStudent-report",
          allowedRoles: [4],
        },
        {
          label: "View Assignment Report",
          icon: PieChartIcon,
          path: "/viewAssignment-report",
          allowedRoles: [4],
        },
        {
          label: "TC Issue Report",
          icon: PieChartIcon,
          path: "/tCissue-report",
          allowedRoles: [4],
        },
        {
          label: "Update Student Information Report",
          icon: PieChartIcon,
          path: "/updateStudentInformation-report",
          allowedRoles: [4],
        },
        {
          label: "Male Female Ratio Report",
          icon: PieChartIcon,
          path: "/maleFemaleRatio-report",
          allowedRoles: [4],
        },
        {
          label: "Migration from Branch Report",
          icon: PieChartIcon,
          path: "/migrationFromBranch-report",
          allowedRoles: [4],
        },
        {
          label: "Migrated to Branch Report",
          icon: PieChartIcon,
          path: "/migratedToBranch-report",
          allowedRoles: [4],
        },
        {
          label: "Deactivated Student Report",
          icon: PieChartIcon,
          path: "/deactivatedStudent-report",
          allowedRoles: [4],
        },
        {
          label: "New Admission Ratio Report",
          icon: PieChartIcon,
          path: "/newAdmissionRatio-report",
          allowedRoles: [4],
        },
        {
          label: "Student Strength Graph",
          icon: PieChartIcon,
          path: "/studentStrengthGraph-report",
          allowedRoles: [4],
        },
      ],
    },
    {
      label: "Reports",
      icon: EqualizerIcon,
      allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
      subMenu: [
        {
          label: "School Wise Report",
          icon: PieChartIcon,
          path: "/hostel-report",
          allowedRoles: [8,  11, 12, 13],
        },
        {
          label: "Student Attendance Report",
          icon: PieChartIcon,
          path: "/student-attendance-report",
          allowedRoles: [9],
        },
        {
          label: "Birthday Calender Report",
          icon: PieChartIcon,
          path: "/birthday-report",
          allowedRoles: [9],
        },
        {
          label: "Counselling Form Report",
          icon: PieChartIcon,
          path: "/counselling-report",
          allowedRoles: [9],
        },
        {
          label: "Deactivated Student  Report",
          icon: PieChartIcon,
          path: "/deactivatedstudent-report",
          allowedRoles: [9],
        },
        {
          label: "School Wise Student Report",
          icon: PieChartIcon,
          path: "/schoolreport",
          allowedRoles: [8, 11, 12, 13],
        },
        {
          label: "Inventory Report",
          icon: PieChartIcon,
          path: "/assetreport",
          allowedRoles: [1],
        },
        {
          label: "School Requirements",
          icon: PieChartIcon,
          path: "/requirementreport",
          allowedRoles: [1],
        },
        {
          label: "Vendor Report",
          icon: PieChartIcon,
          path: "/vendorreport",
          allowedRoles: [1],
        },

        {
          label: "Amenity Stocking Report",
          icon: PieChartIcon,
          path: "/amenity-report",
          allowedRoles: [4],
        },
        {
          label: "Allocated Limits Report",
          icon: PieChartIcon,
          path: "/limit-report",
          allowedRoles: [999],
        },
        {
          label: "Requirements Status Report",
          icon: PieChartIcon,
          path: "/req-status-report",
          allowedRoles: [1, 4, 5, 6, 7, 8, 11, 12, 13],
        },
        {
          label: "Legacy Requirements Status Report",
          icon: PieChartIcon,
          path: "/legacy-status-report",
          allowedRoles: [8, 11, 12, 13],
        },
        {
          label: "Hostel Unique Code Report",
          icon: PieChartIcon,
          path: "/unique-code-report",
          allowedRoles: [8, 11, 12, 13],
        },
        {
          label: "Precurement Report",
          icon: PieChartIcon,
          path: "/precurement-report",
          allowedRoles: [6, 7, 8, 11, 12, 13],
        },
      ],
    },

    {
      label: "Transfer",
      icon: NextWeek,
      allowedRoles: [14, 15],
      subMenu: [
        {
          label: "Head Master",
          icon: AccountCircleIcon,
          path: "/transfer-headmaster",
          allowedRoles: [15],
        },
        {
          label: "Student",
          icon: AccountCircleIcon,
          path: "/transfer-student",
          allowedRoles: [15],
        },
        {
          label: "WEO",
          icon: AccountCircleIcon,
          path: "/transfer-WEO",
          allowedRoles: [14],
        },
        {
          label: "DWO",
          icon: AccountCircleIcon,
          path: "/transfer-DWO",
          allowedRoles: [14],
        },
      ],
    },

    {
      label: "Time Table",
      icon: ScheduleIcon,
      allowedRoles: [9],
      subMenu: [
        {
          label: "My Time Table",
          icon: ContentPasteIcon,
          path: "/teacher-timetable",
          allowedRoles: [9],
        },
        {
          label: "School Time Table",
          icon: ContentPasteIcon,
          path: "/school-timetable",
          allowedRoles: [9],
        },
      ],
    },

    {
      label: "Feedback",
      icon: FeedbackIcon,
      allowedRoles: [9],
      subMenu: [
        {
          label: "Send Feedback",
          icon: FeedbackIcon,
          path: "/send-feedback",
          allowedRoles: [9],
        },
        {
          label: "Send Feedback Report",
          icon: FeedbackIcon,
          path: "/feedback-report",
          allowedRoles: [9],
        },
        {
          label: "Student Feedback",
          icon: FeedbackIcon,
          path: "/student-feedback",
          allowedRoles: [9],
        }
      ]
    },

    {
      label: "Student Leave",
      icon: PersonIcon,
      allowedRoles: [9, 10],
      subMenu: [
        {
          label: "Apply Student Leave",
          icon: PersonIcon,
          path: "/student_apply_leave",
          allowedRoles: [10],
        },
        {
          label: "View Leave",
          icon: PersonIcon,
          path: "/view_student_leave",
          allowedRoles: [9],
        },
        {
          label: "Student Leave Report",
          icon: PersonIcon,
          path: "/student_leave_report",
          allowedRoles: [9],
        }
      ]
    },

    {
      label: "Award List",
      icon: EmojiEventsIcon,
      path: "/award_list",
      allowedRoles: [9],
    },
    {
      label: "Photo Gallery",
      icon: CollectionsIcon,
      path: "/photo-gallery",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13],
    },
    {
      label: "Food Menu",
      icon: RestaurantMenuIcon,
      path: "/food-menu",
      allowedRoles: [4],
    },
    {
      label: "View Food Menu",
      icon: RestaurantMenuIcon,
      path: "/food-menu-view",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14],
    },
    {
      label: "Bulk SMS",
      icon: BulkSmsIcon,
      path: "/bulk-sms",
      allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    },
    {
      label: "Assigned Students",
      icon: TeacherIcon,
      path: "/assigned-teachers",
      allowedRoles: [4],
    },
    {
      label: "View Assigned Students",
      icon: TeacherIcon,
      path: "/view-assigned-students",
      allowedRoles: [9],
    },
    {
      label: "Hostel Bed Allotment",
      icon: SingleBedIcon,
      path: "/bed-allotment",
      allowedRoles: [4, 10],
    },
    {
      label: "Add Hostel Workers",
      icon: Diversity3Icon,
      path: "/add-hostel-workers",
      allowedRoles: [9],
    },
    {
      label: "View Hostel Workers",
      icon: Diversity3Icon,
      path: "/view-hostel-workers",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14],
    },
    {
      label: "Bill Management System",
      icon: ReceiptIcon,
      path: "/bill-management-system",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14],
    },
    {
      label: "Hostel Attendance",
      icon: EventIcon,
      path: "/hostel-attendance",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,12,13,14],
    },
  ];

  const renderSidebarMenuItems = (role, t) => {
    return sidebarMenuItems
      .filter((item) => item.allowedRoles.includes(role))
      .map((item) => {
        if (item.subMenu) {
          return (
            <SubMenu
              label={t(item.label)}
              icon={<item.icon />}
              className="SubMenu"
            >
              {item.subMenu
                .filter((subItem) => subItem.allowedRoles.includes(role))
                .map((subItem) => (
                  // Wrap the MenuItem content in a Link for the subMenu
                  <Link
                    to={subItem.path}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <MenuItem
                      icon={<subItem.icon />}
                      className={
                        activeMenu === subItem.path
                          ? "menuItem active"
                          : "menuItem"
                      }
                    >
                      {t(subItem.label)}
                    </MenuItem>
                  </Link>
                ))}
            </SubMenu>
          );
        } else {
          // Wrap the MenuItem content in a Link for the main menu
          return (
            <Link
              to={item.path}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <MenuItem
                icon={<item.icon />}
                className={
                  activeMenu === item.path ? "menuItem active" : "menuItem"
                }
              >
                {t(item.label)}
                {item.additionalIcon && (
                  <item.additionalIcon sx={{ color: "#d60606" }} />
                )}
              </MenuItem>
            </Link>
          );
        }
      });
  };

  return (
    <div className="maindiv" style={{ display: "flex", overflow: "none" }}>
      <div
        className="bars"
        style={{ left: "1%", top: "1%" }}
        onClick={toggleSidebar}
      >
        <UilBars />
      </div>

      <Sidebar
        className="sidebar hide-on-print"
        collapsed={!expanded}
        style={{ left: expanded ? "0" : "-250px" }}
      >
        <Menu>
          <div className="logo">
            <span>
              <img src={title} alt="title" />
            </span>
          </div>
          {renderSidebarMenuItems(props.role, t)}
          <MenuItem icon={<LogoutRoundedIcon />} onClick={logout}>
            {t("Logout")}
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default React.memo(Sidebarrs);
